"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { useParams } from "next/navigation"
import { useMemo } from "react"
import { twMerge } from "tailwind-merge"

import { generateResponsiveCSS } from "../../../lib/helper"
import type { CategoryConfig } from "../../tamda-media/TamdaMediaNewsLayout/types/config"
import { NewsSwiperContent } from "./components/NewsSwiperContent"
import { useNewsSwiper } from "./hooks/useNewsSwiper"

export interface NewsSwiperRenderProps {
  title: string
  websiteDomain: string
  categories: CategoryConfig[]
  slidesPerView: number
  spaceBetween: number
  className: string
  styles?: {
    mobile?: Record<string, unknown>
    tablet?: Record<string, unknown>
    desktop?: Record<string, unknown>
  }
  responsiveType?: "desktopFirst" | "mobileFirst"
  id?: string
}

export const RenderConfig = {
  render: ({
    title,
    websiteDomain,
    categories,
    slidesPerView,
    spaceBetween,
    className,
    styles,
    responsiveType,
    id: componentId,
  }: NewsSwiperRenderProps) => {
    const params = useParams()
    const storeLocale = useUIBuilderLocaleStore(state => state.locale)
    const locale = (params?.locale as string) || storeLocale || "vi"
    const id = useMemo(() => componentId || `news-swiper-${Math.random().toString(36).substr(2, 9)}`, [componentId])
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)
    const { posts, postsData, loading, selectedCategoryId, setSelectedCategoryId } = useNewsSwiper(categories, websiteDomain, 20, locale)

    return (
      <>
        {responsiveCSS}
        <div className={twMerge(className)} id={id}>
          <NewsSwiperContent
            id={id}
            title={title}
            categories={categories}
            locale={locale}
            posts={posts}
            postsData={postsData}
            slidesPerView={slidesPerView}
            spaceBetween={spaceBetween}
            loading={loading}
            selectedCategoryId={selectedCategoryId}
            onCategoryClick={setSelectedCategoryId}
            className={className}
          />
        </div>
      </>
    )
  },
}
